import { types, getParent, destroy } from 'mobx-state-tree';
import { SurfAmount } from './SurfAmount';
import { MsgAmount } from './MsgAmount';
import { CallsAmount } from './CallsAmount';
import { SubscriptionProps } from './SubscriptionProps';

export const Subscription = types
    .model({
        number: types.string,
        name: types.string,
        surfAmount: SurfAmount,
        msgAmount: MsgAmount,
        callsAmount: CallsAmount,
        properties: SubscriptionProps,
    })
    .actions(self => ({
        changeName(newName: string) {
            self.name = newName;
        },
        remove() {
            getParent(self, 2).remove(self);
        }
    }));

export const SubscriptionList = types
    .model({
        items: types.optional(types.array(Subscription), []),
        selectedSubscriptionNumber: types.optional(types.string, ''),
    })
    .views(self => ({
        get selectedSubscription() {
            let subscription = self.items.find(subscr => subscr.number === self.selectedSubscriptionNumber);
            if (subscription !== undefined) {
                return subscription; 
            } else {              
                return self.items[0];              
            }          
        }
    }))
    .actions(self => ({
        add(item: typeof Subscription.Type) {
            self.items.push(item);
        },
        remove(item: typeof Subscription.Type) {
            destroy(item);
        },
        clear() {
            self.selectedSubscriptionNumber = '';
            self.items.clear();
        },
        setSelectedSubscription(subscriptionNumber: string) {
            self.selectedSubscriptionNumber = subscriptionNumber;
        }
    }));


// WEBPACK FOOTER //
// ./src/models/SubscriptionList.ts